module.exports = __webpack_public_path__ + "img/skin-diagnostic-result-fr.9bb36e1c.jpg";